import router, { errRoutes } from "@/router";
import store from "@/store";
import VabProgress from "nprogress";
import "nprogress/nprogress.css";
import getPageTitle from "@/utils/pageTitle";
import { progressBar, routesWhiteList } from "./settings";
import { resetRouter } from "@/router";
import { getUserInfo } from "@api/framework/org/users";

VabProgress.configure({
  easing: "ease",
  speed: 500,
  trickleSpeed: 200,
  showSpinner: false,
});
router.beforeResolve(async (to, from, next) => {
  let curRole = store.getters["user/curRole"];
  let token = store.getters["user/accessToken"];
  const hasPermissions =
    store.getters["user/permissions"] &&
    store.getters["user/permissions"].length > 0;
  if (token) {
    if (hasPermissions) {
      next();
    } else {
      const res = await getUserInfo();
      if (res.success) {
        await resetRouter();
        await store.dispatch("user/resetUserInfo", res.data);
        curRole = store.getters["user/curRole"];
        let accessRoutes = await store.dispatch("routes/setRoutes", curRole);
        router.addRoutes(accessRoutes);
        const path = to.path;
        if (
          accessRoutes.some((value) => {
            if (value.path == "/") {
              return false;
            } else {
              return path.indexOf(value.path) > -1;
            }
          })
        ) {
          next({ ...to, replace: true });
        } else {
          next("/");
        }
      } else {
        await store.dispatch("user/resetAccessToken");
        next({ path: "/" });
      }
    }
  } else {
    next();
  }
  document.title = getPageTitle(to.meta.title);
});
router.afterEach(() => {
  if (progressBar) VabProgress.done();
});
